import * as Yup from "yup";
import { REGEX } from "../../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */

export const validateInit = {
    error:[],
    otherreason:false,
    note:'',
    notify:false
}